//axios api
import api from "@/lib/Api";
import moment from "moment";
export const getAllRefillList = async () => {
  try {
    const queryRoute = `/stock/getAllRefillList`;

    const fetchRes = api.axios.post(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
export const exportStocktakeSummary = async (
  filterAdmin,
  startDate,
  endDate,
  searchStaffCode
) => {
  try {
    const queryRoute = `/stock/exportStocktakeSummary`;

    const reqBody = {
      filterAdmin,
      startDate,
      endDate,
      searchStaffCode,
    };

    const fetchRes = api.axios.post(queryRoute, reqBody, {
      responseType: "blob",
    });

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const mergeDeliveryOrderItem = async (data) => {
  try {
    const reqBody = {
      data,
    };

    const queryRoute = `/stock/mergeDeliveryOrderItem`;

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
export const updateDeliveryOrder = async (
  si_number,
  stockonhand_refill_id,
  status
) => {
  try {
    const reqBody = {
      si_number,
      stockonhand_refill_id,
      status,
    };

    const queryRoute = `/stock/updateDeliveryOrder`;

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    throw err;
  }
};
export const getStocktakeItemdDiffById = async (stockTakeId) => {
  try {
    const reqBody = {
      stockTakeId,
    };

    const queryRoute = `/stock/getStocktakeItemdDiffById`;

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
export const getSohList = async () => {
  try {
    const queryRoute = `/stock/getSohList`;

    const fetchRes = api.axios.post(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
export const getPendingDeliveryOrderItemList = async (filterAdmin) => {
  try {
    const queryRoute = `/stock/getPendingDeliveryOrderItemList`;
    const reqBody = {
      filterAdmin,
    };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
export const getStocktakeList = async (
  filterAdmin,
  startDate,
  endDate,
  searchStaffCode
) => {
  try {
    const reqBody = {
      filterAdmin,
      startDate: moment(startDate).format("YYYY-MM-DD"),
      endDate: moment(endDate).format("YYYY-MM-DD"),
      searchStaffCode,
    };

    const queryRoute = `/stock/getStocktakeList`;

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
export const getDeliveryOrderItemList = async (
  stockonhand_refill_id,
  si_number
) => {
  try {
    const reqBody = {
      stockonhand_refill_id,
      si_number,
    };
    const queryRoute = `/stock/getDeliveryOrderItemList`;

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getDeliveryOrderList = async (
  startDate,
  endDate,
  searchStaffCode
) => {
  try {
    const reqBody = {
      startDate: moment(startDate).format("YYYY-MM-DD"),
      endDate: moment(endDate).format("YYYY-MM-DD"),
      searchStaffCode,
    };
    const queryRoute = `/stock/getDeliveryOrderList`;

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getRefillListById = async (userId, isExport, isApprove) => {
  try {
    const queryRoute = `/stock/getRefillListById/${userId}`;

    const reqBody = {
      isExport: isExport,
      isApprove: isApprove,
    };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getAllExportRefillList = async () => {
  try {
    const queryRoute = `/stock/getAllExportRefillList`;

    const fetchRes = api.axios.post(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const approveStockOnHandList = async (data) => {
  try {
    const queryRoute = `/stock/approveStockOnHandList`;

    const reqBody = {
      data: data,
    };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const editStockOnHandList = async (data) => {
  try {
    const queryRoute = `/stock/editStockOnHandList`;

    const reqBody = {
      data: data,
    };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getStockOnHandManageById = async (id) => {
  try {
    const queryRoute = `/stock/getStockOnHandManageById/${id}`;

    const fetchRes = api.axios.post(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getStockOnHandTypeManageById = async (
  masterUserId,
  masterItemId
) => {
  try {
    const reqBody = { masterUserId, masterItemId };

    const queryRoute = `/stock/getStockMovement`;

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getStockAdjustReason = async (platform, type) => {
  try {
    const reqBody = { platform, type };
    const queryRoute = `/stock/getStockAdjustRequestReason`;

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getStockAdjustRequestReason = async (type) => {
  try {
    const queryRoute = `/stock/getStockAdjustRequestReason`;
    const reqBody = { platform: "web", type };

    const result = await api.axios.post(queryRoute, reqBody);

    return result.data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getExchangeInvoice = async (
  invoiceId,
  shopCode,
  startDate,
  endDate
) => {
  try {
    const queryRoute = `/stock/getExchangeInvoice/${invoiceId}`;
    const reqBody = { shopCode, startDate, endDate };
    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getReturnInvoice = async (
  invoiceId,
  shopCode,
  startDate,
  endDate
) => {
  try {
    const queryRoute = `/stock/getReturnInvoice/${invoiceId}`;
    const reqBody = { shopCode, startDate, endDate };
    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getStockonhandListByUser = async (fromUser, type) => {
  try {
    const queryRoute = `/stock/getStockonhandListByUser`;
    const reqBody = { fromUser, type };
    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const createTransferInvoice = async (body) => {
  try {
    const queryRoute = `/stock/createStockTransferRecord`;
    const reqBody = { ...body };
    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getTransferInvoice = async (shopCode, startDate, endDate) => {
  try {
    const queryRoute = `/stock/getTransferInvoice`;
    const reqBody = { shopCode, startDate, endDate };
    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getTransferInvoiceById = async (invoiceId) => {
  try {
    const queryRoute = `/stock/getTransferInvoice/${invoiceId}`;
    const fetchRes = api.axios.post(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
